import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';

import { Tabs } from 'components';
import { AuthContext, isOrgFeatureEnabled, useSpot } from 'framework';

type StaffTab = 'users' | 'leaveAnalytics' | 'orgChart' | 'leaveBalances';

interface Props {
  organization: string;
  selected: StaffTab;
  children: React.ReactNode;
}

export function StaffTabs({ organization, selected, children }: Props) {
  const history = useHistory();
  const { isInitialized, getGroups } = useContext(AuthContext);
  const { data, query } = useSpot();
  const callerGroups = isInitialized() ? getGroups() : [];
  const canViewUsers = callerGroups.includes('administrators');
  const org = data?.organizations?.[organization];
  const tabContent = <>{children}</>;

  useEffect(() => {
    if (!org) {
      query(`org/${organization}`, {}, ['organizations', organization]);
    }
  }, [org, organization, query]);

  // Tab order: Staff → Leave Analytics → Leave Balances → Org Chart
  const tabs: { [k: string]: JSX.Element } = {};
  if (canViewUsers) {
    tabs.users = tabContent;
  }
  if (canViewUsers && isOrgFeatureEnabled(org, 'leave')) {
    tabs.leaveAnalytics = tabContent;
  }
  if (isOrgFeatureEnabled(org, 'leave')) {
    tabs.leaveBalances = tabContent;
  }
  tabs.orgChart = tabContent;

  const onTabChange = (tab: string) => {
    if (tab === 'users' && canViewUsers) {
      history.replace(`/${organization}/users`);
      return;
    }
    if (tab === 'leaveAnalytics' && canViewUsers) {
      history.replace(`/${organization}/users/leave-analytics`);
      return;
    }
    if (tab === 'leaveBalances') {
      history.replace(`/${organization}/users/leave-balances`);
      return;
    }
    if (tab === 'orgChart') {
      history.replace(`/${organization}/users/org-chart`);
    }
  };

  return <Tabs selected={selected} tabs={tabs} onTabChange={onTabChange} />;
}

